"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaMempoolTransactionRequestToJSON = exports.RosettaMempoolTransactionRequestFromJSONTyped = exports.RosettaMempoolTransactionRequestFromJSON = void 0;
const _1 = require("./");
function RosettaMempoolTransactionRequestFromJSON(json) {
    return RosettaMempoolTransactionRequestFromJSONTyped(json, false);
}
exports.RosettaMempoolTransactionRequestFromJSON = RosettaMempoolTransactionRequestFromJSON;
function RosettaMempoolTransactionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network_identifier': _1.NetworkIdentifierFromJSON(json['network_identifier']),
        'transaction_identifier': _1.TransactionIdentifierFromJSON(json['transaction_identifier']),
    };
}
exports.RosettaMempoolTransactionRequestFromJSONTyped = RosettaMempoolTransactionRequestFromJSONTyped;
function RosettaMempoolTransactionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network_identifier': _1.NetworkIdentifierToJSON(value.network_identifier),
        'transaction_identifier': _1.TransactionIdentifierToJSON(value.transaction_identifier),
    };
}
exports.RosettaMempoolTransactionRequestToJSON = RosettaMempoolTransactionRequestToJSON;
//# sourceMappingURL=RosettaMempoolTransactionRequest.js.map